import { useTranslation } from 'react-i18next';
import { Price } from '../Price/Price';
import styles from './SplitByItemsMode.module.scss';
import type { SelectableSplitBillItemRow } from './splitByItems.util';

interface Props {
  row: SelectableSplitBillItemRow;
  onToggle: (row: SelectableSplitBillItemRow) => void;
}

export const SplitByItemsRow = ({ row, onToggle }: Props) => {
  const { t } = useTranslation();

  return (
    <label
      className={`${styles.itemRow} ${row.isLocked ? styles.locked : ''}`}
      data-testid={`split-by-items-row-${row.key}`}
    >
      <span className={styles.itemDetails}>
        <span className={styles.itemName}>{row.item.name}</span>
        {row.item.modifiers.length > 0 && (
          <span className={styles.modifiers}>
            {row.item.modifiers.map(modifier => (
              <span className={styles.modifier} key={`${row.key}-${modifier.name}`}>
                {modifier.name}
                {modifier.quantity > 1
                  ? t('checkout.bill.modifierQuantity', { quantity: modifier.quantity })
                  : ''}
              </span>
            ))}
          </span>
        )}
      </span>
      <span className={styles.itemPrice}>
        <Price amount={row.item.amount} />
      </span>
      <input
        className={styles.checkbox}
        type="checkbox"
        checked={row.isSelected}
        disabled={row.isLocked}
        onChange={() => {
          onToggle(row);
        }}
        aria-label={`${row.item.name} ${row.occurrence}`}
      />
    </label>
  );
};
